import { render, staticRenderFns } from "./IntroView.vue?vue&type=template&id=b8da7088&scoped=true&"
import script from "./IntroView.vue?vue&type=script&lang=js&"
export * from "./IntroView.vue?vue&type=script&lang=js&"
import style0 from "./IntroView.vue?vue&type=style&index=0&id=b8da7088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8da7088",
  null
  
)

export default component.exports